import React from "react"
import { IconSeeker, LoadingIconSeeker, TabsSeeker } from "@ui-seeker/core"
import { INFO_MODAL_TABS } from "Pages/ReportsAlerts/Reports/@constants"
import { isInfoModalHistoryLoading, selectedInfoModalTab } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportInfoModalTabs({ timestampLastExecution }) {

	return <TabsSeeker
		value={selectedInfoModalTab.value}
		onChange={(_, e) => selectedInfoModalTab.value = e}
		tabs={[{
			key: INFO_MODAL_TABS.DETAILS,
			label: 'Report Details',
			value: INFO_MODAL_TABS.DETAILS,
			iconPosition: 'end',
			icon: <IconSeeker icon="memo-circle-info" variant="solid"/>,
			sx: { fontSize: "1.2rem" }
		}, {
			key: INFO_MODAL_TABS.HISTORY,
			label: 'Report History',
			disabled: !timestampLastExecution,
			value: INFO_MODAL_TABS.HISTORY,
			iconPosition: 'end',
			icon: isInfoModalHistoryLoading.value
				? <LoadingIconSeeker/>
				: <IconSeeker icon="rectangle-history"/>,
			sx: { fontSize: "1.2rem" }
		}]}
	/>
}